import Collapse from 'antd/lib/collapse'
import './index.less'

export default Collapse



// WEBPACK FOOTER //
// ./src/elements/collapse/index.js